import { useContext, useState, FC, useEffect } from 'react'

import { Salary, SalaryFilterKeyString } from 'InstitutionalManagement/types'
import { SALARY_INITIAL_FILTER } from 'InstitutionalManagement/constants/pages/salaries'
import CustomFormSalarySelectionDrawerManagerContext from './Context'
import readSalariesOnCustomForm from './services/readSalariesOnCustomForm'

type Props = {
  questionKey: string
  children: JSX.Element
}

const CustomFormSalarySelectionDrawerManagerProvider: FC<Props> = ({ questionKey, children }) => {
  const [view, setView] = useState<string>('SEARCH_SALARY')
  const [selectedSalary, setSelectedSalary] = useState<Salary>({})
  const [loadingSalaries, setLoadingSalaries] = useState<boolean>(true)
  const [salaries, setSalaries] = useState<Salary[]>([])
  const [filter, setFilter] = useState<SalaryFilterKeyString>(SALARY_INITIAL_FILTER)

  async function loadSalary() {
    setLoadingSalaries(true)
    const filters = {
      filter,
      pagination: {
        page: 1,
        limit: 0,
      },
    }

    const response = await readSalariesOnCustomForm({ filters })

    if (response?.header?.success) {
      const salariesFromAPI = response?.body?.salary?.elements
      setSalaries(salariesFromAPI || [])
    }
    setLoadingSalaries(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_SALARY') loadSalary()
  }, [filter])

  return (
    <CustomFormSalarySelectionDrawerManagerContext.Provider
      value={{
        view,
        setView,
        selectedSalary,
        setSelectedSalary,
        filter,
        setFilter,
        questionKey,
        salaries,
        loadingSalaries,
        setLoadingSalaries,
      }}
    >
      {children}
    </CustomFormSalarySelectionDrawerManagerContext.Provider>
  )
}

export const useCustomFormSalarySelectionDrawerManager = () => useContext(CustomFormSalarySelectionDrawerManagerContext)

export default CustomFormSalarySelectionDrawerManagerProvider
